export enum InjectionFeature {
    Unknown = 0,
    AvatarBundle = 1,
    ArenaTicket = 2,
    QuestBoost = 3,
    CreditTicket = 4,
    ScratchTicket = 5,
    AvatarBackground = 6,
    AddChips = 10
}

export interface RewardLinkableItemData {
    feature: InjectionFeature;
    itemId: number;
    itemName: string;
}

export class RewardItem {
    constructor(
        public feature: InjectionFeature | number = 0,
        public itemId: number = 0,
        public itemName: string = ''
    ) {}
}

export class RewardItemDetail extends RewardItem {
    constructor(
        public feature: InjectionFeature | number = 0,
        public itemId: number = 0,
        public itemName: string = '',
        public itemLink: string = ''
    ) {
        super(feature, itemId, itemName);
    }
}

export type RewardFormState = {
    data: number | null;
    quantity: number;
    feature?: InjectionFeature | number | null;
};

export interface RewardFeatureConfig {
    value: InjectionFeature;
    label: string;
    dataLabel: string;
    quantityLabel: string;
    canEditData: boolean;
    canEditQuantity: boolean;
}

export const RewardFeatures: RewardFeatureConfig[] = [
    {
        value: InjectionFeature.AvatarBundle,
        label: 'AvatarBundle',
        dataLabel: 'ItemId',
        quantityLabel: 'Quantity',
        canEditData: false,
        canEditQuantity: false
    },
    {
        value: InjectionFeature.ArenaTicket,
        label: 'ArenaTicket',
        dataLabel: 'Data',
        quantityLabel: 'Quantity',
        canEditData: false,
        canEditQuantity: true
    },
    {
        value: InjectionFeature.QuestBoost,
        label: 'QuestBoost',
        dataLabel: 'ItemId',
        quantityLabel: 'Duration',
        canEditData: false,
        canEditQuantity: true
    },
    {
        value: InjectionFeature.CreditTicket,
        label: 'CreditTicket',
        dataLabel: 'Amount',
        quantityLabel: 'Quantity',
        canEditData: true,
        canEditQuantity: false
    },
    {
        value: InjectionFeature.ScratchTicket,
        label: 'ScratchTicket',
        dataLabel: 'Data',
        quantityLabel: 'Quantity',
        canEditData: false,
        canEditQuantity: true
    },
    {
        value: InjectionFeature.AvatarBackground,
        label: 'AvatarBackground',
        dataLabel: 'ItemId',
        quantityLabel: 'Quantity',
        canEditData: false,
        canEditQuantity: false
    }
];
